import React from 'react';
import { Danger } from 'src/assets/dynamicSvg';
import styled from 'styled-components';
import { AssessmentState } from '../types';
import { Tooltip } from 'src/common';
import { getStateWarningMessage } from '../util';

const Div = styled.div`
  margin-right: auto;
`;

interface DangerTooltipProps {
  state?: AssessmentState;
  tooltipHtml?: string;
}

export const DangerTooltip: React.FC<DangerTooltipProps> = ({ state, tooltipHtml = '' }) => {
  return (
    <Div>
      <Tooltip dataHtml={state ? getStateWarningMessage(state, true) : tooltipHtml} dataId="danger-tooltip" place="top">
        <Danger />
      </Tooltip>
    </Div>
  );
};
